<template>
  <div class="art3">
    <div>
      <img src="~@/assets/images/art-page3-img-1.jpg" />
    </div>
    <div>&nbsp;</div>
    <div>
      2010年獲行政院文建會指定為『人間國寶』的「交趾陶保存修復技術」保存者林洸沂老師，嘉義縣新港鄉月眉村人，在就讀初中時，因村子裡的廟宇重建，開啟了林洸沂對廟宇藝術的興趣，進而入林萬有師傳的門下學習剪粘技藝與宗教藝術。
    </div>
    <div>&nbsp;</div>
    <div>
      林洸沂從一名小學徒，成為建築師傳，在其燒陶技術已獨當一面時，仍對燒陶釉色不滿，1980年再拜林添木先生門下，學習交趾陶釉方、釉藥調配與煉製的技巧，同時於棄努力多年的建廟工作，全力投入交趾陶的製作、研究與改良，將交趾陶燒製的溫度大幅提昇以利保存，且對釉色的研究亦有突破，讓交趾陶的外衣更加亮麗多彩，開啟了交趾陶藝的新紀元。
    </div>
    <div>&nbsp;</div>
    <div>
      林洸沂出身於傳統剪粘司傅，在自我要求與訓練中，輚變為著名的交趾陶創作大師，作品的最大特色，在走出傳統融合現代，讓交趾陶從廟宇建築工藝轉型為純欣賞的藝術品，尤其注重作品背景資料的考據，使他的作品呈現出栩栩如生而寓意深遠的意境。屢屢獲得台灣與國際上的肯定，作品曾在美國紐約、舊金山、洛杉磯、日本、法國巴黎與土耳其等地的術館、藝郎與博物館展出。
    </div>
    <div>&nbsp;</div>
    <div>
      在創作藝術之外，林洸沂更長期維護並推動民俗技術，並對交趾陶保存修復貢獻良多。透過林洸沂的巧手，修復台灣交趾陶祖師爺葉王的許多作品，讓這些文物能繼續傳承給後代子孫。
    </div>
    <div>&nbsp;</div>
    <div>
      <strong>『林洸沂文衡殿照壁創作，國寶藝術無可取代』</strong>
    </div>
    <div>&nbsp;</div>
    <div>
      為感念文衡聖帝神恩浩蕩，共推廣融合現代的傳統宗教藝術，日前，文衡殿邀請行政院文建會指定為「交趾陶保存修復技術」的台灣人間國寶林洸沂大師，為文衡殿創作三件照壁交趾陶，日月蓮臺、松鶴延年、竹鹿長青為主題，如此大面積壁照藝術作品，在台灣宗教建築機乎已經很少見了，加上全出自林洸沂大師手筆，以及需歷經數個月的高難度拆解、燒製、上釉，才能維持整件作品的色調一致，安裝時更需要依序上釘、黏合，方能完美呈現整件作品，『國寶級的大師，國寶級的作品』藝術價值性無可取代。
    </div>
  </div>
</template>

<script>
export default {
  name: 'Art3',
  data() {
    return {
      page: this.$route.query.page,
    };
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
};
</script>

<style scoped>
.art3 img {
  max-width: 100%;
}
</style>
